import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.css']
})
export class ApplicationsComponent implements OnInit {
  cardHeight = '300';
  cardWidth = '200';
  
  public welcomeHVSApplications = "HealthView's applications are designed to serve as a quick and easy financial planning platform with minimal inputs and easy-to-understand outputs. The reports can help advisors initiate conversations with clients about their specific retirement needs and possible long-term solutions."
  private navCards = [];
  
  constructor() {
    var orgApps = JSON.parse(localStorage.getItem('orgApps'));
    for(let app of orgApps){
      this.navCards.push({ title: app.AppName, 
        description: app.AppDesc, 
        icon: '', 
        color: app.Color, 
        iconColor: '', 
        image: app.DisplayImage,
        fromApplicationStore: true,
        //TODO: need to fix this - right now this is handled in nav-card.componenet.ts and applications-link.componenet.ts
        //nav-card should be changed to pass a url and use that url if one is passed
        applicationLink: app.DisplayCode,

        //iframes do not need this button
        actionButton: (app.AppType > 1)});

        //console.log('app displaycode', app.DisplayCode);
    }    
  }

  ngOnInit() {
    
  }
}
